export default __webpack_public_path__ + "static/media/new_user_activity_23.1eff6ac9.png";